// AUTO-GENERATED by tools/measure-ink-offsets.mjs — DO NOT hand-edit.
// Run `npm run fonts:ink` to regenerate (do this whenever fonts are added/changed).
//
// Per-font CAP-HEIGHT as a fraction of EM (the measured ink height of uppercase glyphs).
// render-engine.js positions the weight lockup's number/unit + the ruled rules off this so
// the vertical GAPS stay constant across fonts instead of jumping with each face's metrics.
export default {
  "abril": 0.68,
  "alfaslab": 0.748,
  "annie": 0.626,
  "anton": 0.82,
  "archivo": 0.658,
  "archivoblack": 0.656,
  "archivonarrow": 0.658,
  "baloo": 0.59,
  "bangers": 0.68,
  "barlow": 0.672,
  "barlowcond": 0.668,
  "bbhbartle": 0.668,
  "bebas": 0.672,
  "bigshoulders": 0.77,
  "blackops": 0.622,
  "bodoni": 0.734,
  "bowlby": 0.714,
  "bowlbyone": 0.718,
  "bungee": 0.688,
  "bungeeshade": 0.822,
  "cardo": 0.68,
  "castorotitling": 0.688,
  "caveat": 0.682,
  "chakra": 0.674,
  "changaone": 0.6,
  "chango": 0.668,
  "chivo": 0.66,
  "cinzel": 0.686,
  "cinzeldeco": 0.854,
  "college": 0.662,
  "collegebold": 0.658,
  "collegecond": 0.662,
  "collegesemi": 0.662,
  "courgette": 0.718,
  "courierprime": 0.562,
  "dancing": 0.768,
  "danfo": 0.688,
  "dmsans": 0.674,
  "dmserif": 0.646,
  "dosis": 0.694,
  "ebgaramond": 0.64,
  "epilogue": 0.71,
  "figtree": 0.672,
  "firacond": 0.668,
  "fjallaone": 0.798,
  "fraunces": 0.684,
  "fugaz": 0.69,
  "germania": 0.666,
  "girlnextdoor": 0.644,
  "gloria": 0.8,
  "goldman": 0.564,
  "graduate": 0.73,
  "greatvibes": 0.918,
  "hanken": 0.672,
  "inter": 0.698,
  "jakarta": 0.718,
  "josefin": 0.696,
  "josefinslab": 0.684,
  "jost": 0.672,
  "kanit": 0.616,
  "kaushan": 0.762,
  "khand": 0.658,
  "labelle": 0.792,
  "leaguegothic": 0.702,
  "lexend": 0.672,
  "librebaskerville": 0.752,
  "lilita": 0.664,
  "lobster": 0.728,
  "lora": 0.682,
  "luckiestguy": 0.66,
  "lugrasimo": 0.76,
  "manrope": 0.694,
  "marcellus": 0.684,
  "michroma": 0.736,
  "moderustic": 0.676,
  "monoton": 0.788,
  "montserrat2": 0.67,
  "mulish": 0.678,
  "newamsterdam": 0.618,
  "newrocker": 0.796,
  "nixie": 0.694,
  "nunito": 0.676,
  "ooohbaby": 0.682,
  "orbitron": 0.692,
  "oswald": 0.776,
  "outfit": 0.676,
  "overpass": 0.674,
  "pacifico": 0.878,
  "passionone": 0.594,
  "pathwaygothic": 0.678,
  "paytone": 0.66,
  "permanentmarker": 0.674,
  "playfair": 0.688,
  "playwriteau": 0.974,
  "pompiere": 0.766,
  "poppins": 0.668,
  "prata": 0.79,
  "ptsansnarrow": 0.678,
  "questrial": 0.642,
  "quicksand": 0.666,
  "racingsans": 0.61,
  "rajdhani": 0.614,
  "redhat": 0.672,
  "reenie": 0.636,
  "righteous": 0.67,
  "roboto": 0.68,
  "robotocond": 0.68,
  "rowdies": 0.676,
  "rozha": 0.546,
  "rubik": 0.67,
  "rubikmono": 0.666,
  "rye": 0.736,
  "sairacond": 0.66,
  "sciencegothic": 0.672,
  "shrikhand": 0.638,
  "sigmar": 0.646,
  "silkscreen": 0.598,
  "sora": 0.708,
  "spacegrotesk": 0.676,
  "specialelite": 0.678,
  "spectral": 0.642,
  "squadaone": 0.626,
  "staatliches": 0.666,
  "teko": 0.614,
  "tektur": 0.672,
  "titanone": 0.674,
  "tuffy": 0.684,
  "ultra": 0.694,
  "urbanist": 0.674,
  "worksans": 0.634,
  "yanone": 0.67,
  "yellowtail": 0.686,
  "yeseva": 0.682,
  "ysabeausc": 0.634,
  "zendots": 0.688,
  "zillaslab": 0.628,
};
